import { RedirectWithQuery } from '@xylabs/sdk-react'
import { Route, Routes } from 'react-router-dom'

import AuctionsJsonPage from './Json'
import AuctionsListPage from './List'
import AuctionsPage from './Summary'

const AuctionsRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<AuctionsJsonPage />} path="/json" />
      <Route element={<AuctionsListPage />} path="/:id" />
      <Route element={<AuctionsPage />} path="/*" />
      <Route element={<RedirectWithQuery to="/auctions" />} path="*" />
    </Routes>
  )
}

export { AuctionsRoutes }
